<div id="openModal" class="card pb-0 mb-0">
    <div class="modal-header bg-soft-info p-3">

        <div class="">
            <h5 class="card-title mb-0">Create Color Highlighted Keywords PDF</h5>
        </div>

        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" id="close-modal"
            (click)="dismiss()">
        </button>

    </div>
    <div class="card-body">
        <div *ngIf="spinnerIsShown"
            style="width: 100%; height: 100%; position: absolute; z-index: 100000; display: flex; justify-content: center; align-items: center;">
            <div class="spinner-border text-primary avatar-sm" role="status">
                <span class="visually-hidden">Loading...</span>
            </div>
        </div>
        <div *ngFor="let pair of keywordSearch; let index = index">
            <div class="d-md-flex justify-content-between gap-2">
                <div class="col-12 col-md-9 mb-2">
                    <label for="job-title-Input" class="form-label">Keywords {{index+1}}</label>
                    <!-- <input class="form-control" autocomplete="off" type="text" [(ngModel)]="pair.searchTerm"
                        placeholder="Enter word or phrase to highlight" /> -->
                    <div class="d-flex align-items-center form-control " style="padding: 0%; border-width: 0px; ">
                        <ng-select style="flex-grow: 1; " [multiple]="true" [selectOnTab]="true" typeToSearchText="Add keywords to highlight"
                            placeholder="Add keywords to highlight" [clearSearchOnAdd]="true" [(ngModel)]="pair.searchTerms"
                            [addTag]="addCustomTag" [typeahead]="searchTerm$">
                            <ng-template ng-tag-tmp let-item="item" let-clear="clear">
                                <span class="ng-value-label ">
                                    <span style="font-size: 80% !important; ">
                                        Search for:
                                    </span>
                                    <span>
                                        "{{searchTerm}}"
                                    </span>
                                </span>
                            </ng-template>
                            <ng-template ng-label-tmp let-item="item" let-clear="clear">
                                <div class="d-md-flex">
                                    <span class="ng-value-icon left" (click)="clear(item)">×</span>
                                    <div class="d-flex">
                                        <span class="ng-value-label text-white">
                                            {{item}}
                                        </span>
                                    </div>
                                </div>
                            </ng-template>

                        </ng-select>
                    </div>
                </div>

                <div class="mb-4 col-md-3 ">
                    <div class="d-flex justify-content-center">
                        <label for="job-title-Input" class="form-label"> Highlight Color</label>
                    </div>

                    <div class="d-flex justify-content-center">
                        <div class="cp_wrapper">
                            <input type="color" [(ngModel)]="pair.hexCode" nid="head" name="head" value="#e66465" />
                        </div>
                    </div>

                </div>
            </div>
        </div>
        <div class="hstack gap-2 justify-content-end">
            <button type="submit" (click)="create()" class="btn btn-success" i18n="@@">Create PDF</button>
        </div>
    </div>
</div>